
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import Vuex from 'vuex'
Vue.use(Vuex)
// import store from "@coach/js/store/store";

// const store = new Vuex.Store({
//   state: {
//     count: 0,
//     test: null
//   },
//   mutations: {
//     increment(state) {
//       state.count++;
//     }
//   }
// });

import VueRouter from 'vue-router';
Vue.use(VueRouter);
window.router = new VueRouter({
    mode: 'history'
});

require('cleave.js');

import Toasted from 'vue-toasted';

Vue.use(Toasted,{
    position: 'bottom-center',
    duration: 2000,
    type: 'error',
    iconPack: 'mdi',
    icon: 'mdi-alert'
})

Vue.filter('toFixed', function (val, limit) {
    return parseFloat(val).toFixed(limit);
});

Vue.filter('trimDecimal', function (value) {
  // console.log("trimming: " + value);
  if (!value || isNaN(value)) return "";
  return parseFloat(value).toString();
});

Vue.filter('snakeToTitleCase', function (string) {
  return string.split('_').map(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }).join(' ');
});

import moment from "moment-timezone";
moment.tz.setDefault("UTC");
Vue.use(require('vue-moment'), {moment});

import Clipboard from 'v-clipboard'
Vue.use(Clipboard)

import vueNumeralFilterInstaller from 'vue-numeral-filter';
Vue.use(vueNumeralFilterInstaller);


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('meal-foods', require('./components/MealPlanPanelMealFoodsComponent.vue').default);
Vue.component('meal-component', require('./components/MealPlanPanelMealComponent.vue').default);
Vue.component('mealplan-day-component', require('./components/MealPlanPanelDayComponent.vue').default);
Vue.component('mealplan-week-component', require('./components/MealPlanPanelWeekComponent.vue').default);
Vue.component('mealplan-component', require('./components/MealPlanPanelComponent.vue').default);
Vue.component('workoutplan-component', require('./components/WorkoutPlanPanelComponent.vue').default);
Vue.component('coachingplan-component', require('./components/CoachingPlanPanelComponent.vue').default);
Vue.component('order-items-component', require('./components/OrderItemsComponent.vue').default);
Vue.component('plan-table-component', require('./components/PlanTableComponent.vue').default);
Vue.component('plan-status-badge-component', require('./components/PlanStatusBadgeComponent.vue').default);
Vue.component('email-preview-modal', require('./components/EmailPreviewModalComponent.vue').default);
Vue.component('checkin-preview-modal', require('./components/CheckinPreviewModalComponent.vue').default);
Vue.component('checkin-feedback-modal', require('./components/CoachingPlanCheckinFeedbackModalComponent.vue').default);
Vue.component('checkin-status-badge', require('./components/CoachingPlanCheckinStatusBadgeComponent.vue').default);
Vue.component('checkin-table-component', require('./components/CheckinTableComponent.vue').default);
Vue.component('modal-component', require('./components/ModalComponent.vue').default);
Vue.component('form-modal', require('./components/FormModalComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('modal', {
    template: '#modal-template',
    props: [
        'containerStyle'
    ],
})



// const app = new Vue({
//     el: '#app',
//     data: {

//     },
//     mounted: function mounted() {

//     },
//     methods: {

//     }
// });

function htmlDecode(input)
{
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}
